import type React from 'react';

import type { ChatMessagePart } from 'containers/admin/clients/client/tabs-components/ai-assistant/hooks/use-active-input-part';

import {
  PART_REGISTRY,
  type InlinePartRendererProps,
} from './ai-chat-part-registry';

interface MessagePartsProps {
  parts: ChatMessagePart[];
}

const MessageParts = ({ parts }: MessagePartsProps): React.JSX.Element => (
  <>
    {parts.map((part, index) => {
      const entry = PART_REGISTRY[part.type];

      if (!entry || entry.renderContext !== 'inline') return null;

      const Component =
        entry.component as React.ComponentType<InlinePartRendererProps>;

      return <Component key={`${part.type}-${index}`} data={part.data} />;
    })}
  </>
);

export default MessageParts;
